import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import Datetime from "react-datetime";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Card from "beaktShared/components/Card/Card";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// @material-ui/core components
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";
import CircularProgress from "@material-ui/core/CircularProgress";
import Tooltip from "@material-ui/core/Tooltip";

// icons
import Assignment from '@material-ui/icons/Assignment';
import Close from "@material-ui/icons/Close";
import Edit from "@material-ui/icons/Edit";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import * as ParcelamentoRoyaltiesService from "./ParcelamentoRoyaltiesService";

import { ValidSelect } from "beaktShared/helpers/validselect";
import Select from 'react-select';

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import crudeStyles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from "beaktShared/helpers/extras";
import {
    formateDate,
    formateDateandTime,
    convertDate,
    validateDate,
    getLocale,
    getStringFormatDate,
    MaskMonthYear,
    MaskDecimal,
    MaskInt,
    transformValueFormatedtoFloat,
    transformValueFloattoFormated
} from "beaktShared/helpers/masks";


const useStyles = makeStyles({ ...styles, newButton: crudeStyles.newButton, tooltip: crudeStyles.tooltip });

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const opcoesStatusParcela = [
    { value: "NaoPago", label: "Não Pago" },
    { value: "Pago", label: "Pago" },
];

const getStatusParcelaLabel = (value) => {
    const found = opcoesStatusParcela.find((o) => o.value === value);
    return found ? found.label : (value || "");
};

const textosAmigaveis = {
    Lancado: "Lançado",
    ParcelamentoCriado: "Parcelamento Criado",
    ParcelamentoEditado: "Parcelamento Editado",
    StatusParcelaAtualizado: "Status Parcela Atualizado",
};

const formatarTextoEnum = (value) => {
    if (!value) return "";
    return textosAmigaveis[value] || value;
};

const getStatusParcelaStyle = (value) => {
    if (value === "Pago") return { color: "#2e7d32", background: "#e8f5e9" };
    return { color: "#f57f17", background: "#fff9c4" };
};

const StatusParcelaBadge = ({ value }) => {
    const st = getStatusParcelaStyle(value);
    return (
        <span style={{
            display: "inline-block",
            color: st.color,
            background: st.background,
            padding: "3px 8px",
            borderRadius: "4px",
            fontWeight: 600,
            fontSize: "12px",
            lineHeight: "1.4",
        }}>
            {getStatusParcelaLabel(value)}
        </span>
    );
};

const extrairMensagemErro = (result) => {
    if (!result) return "Erro inesperado";
    if (typeof result.message === "string") return result.message;
    if (result.message && result.message.message) return result.message.message;
    return "Erro inesperado";
};

function ParcelamentoDetalhe({ parcelamento, session }) {
    const classes = useStyles();
    const [loading, setLoading] = React.useState(true);
    const [parcelas, setParcelas] = React.useState([]);
    const [logs, setLogs] = React.useState([]);

    const [modalParcela, setModalParcela] = React.useState(null);
    const [modalStatus, setModalStatus] = React.useState("NaoPago");
    const [modalObservacao, setModalObservacao] = React.useState("");
    const [modalError, setModalError] = React.useState("");
    const [salvandoStatus, setSalvandoStatus] = React.useState(false);

    const carregar = () => {
        setLoading(true);
        Promise.all([
            ParcelamentoRoyaltiesService.getParcelas(parcelamento.parcelamentoRoyaltieId),
            ParcelamentoRoyaltiesService.getLogs(parcelamento.parcelamentoRoyaltieId),
        ]).then(([resultParcelas, resultLogs]) => {
            setLoading(false);
            
            console.log(resultParcelas);
            console.log(resultLogs);

            if (resultParcelas && resultParcelas.status === 200) {
                setParcelas(resultParcelas.data);
            }
            if (resultLogs && resultLogs.status === 200) {
                setLogs(resultLogs.data);
            }
        });
    };

    useEffect(() => {
        carregar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parcelamento.parcelamentoRoyaltieId]);

    const abrirEdicaoStatus = (parcela) => {
        setModalParcela(parcela);
        setModalStatus(parcela.status);
        setModalObservacao("");
        setModalError("");
    };

    const salvarStatus = () => {
        if (!modalObservacao || modalObservacao.trim() === "") {
            setModalError("A Observação é obrigatória.");
            return;
        }

        setModalError("");
        setSalvandoStatus(true);

        const dto = {
            usuarioId: session.id,
            status: modalStatus,
            observacao: modalObservacao,
        };

        ParcelamentoRoyaltiesService.atualizarStatusParcela(modalParcela.parcelamentoRoyaltieParcelaId, dto).then((result) => {
            setSalvandoStatus(false);
            if (!result || (result.status !== 200 && result.status !== 201)) {
                setModalError(extrairMensagemErro(result));
                return;
            }
            setModalParcela(null);
            carregar();
        });
    };

    if (loading) {
        return (
            <div style={{ padding: "16px", textAlign: "center" }}>
                <CircularProgress size={24} />
            </div>
        );
    }

    return (
        <div style={{ padding: "16px 32px", background: "#fafafa" }}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <h5>Parcelas</h5>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ textAlign: "left", borderBottom: "1px solid #ddd" }}>
                                <th style={{ padding: "6px" }}>Mês/Ano</th>
                                <th style={{ padding: "6px" }}>Situação</th>
                                <th style={{ padding: "6px" }}>Status</th>
                                <th style={{ padding: "6px" }}>Observação</th>
                                <th style={{ padding: "6px" }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {parcelas.length === 0 &&
                                <tr><td colSpan={5} style={{ padding: "6px" }}>Nenhuma parcela encontrada.</td></tr>
                            }
                            {parcelas.map((p) => (
                                <tr key={p.parcelamentoRoyaltieParcelaId} style={{ borderBottom: "1px solid #eee" }}>
                                    <td style={{ padding: "6px" }}>{p.mesAno}</td>
                                    <td style={{ padding: "6px" }}>{formatarTextoEnum(p.situacaoParcelRoyaltie)}</td>
                                    <td style={{ padding: "6px" }}><StatusParcelaBadge value={p.status} /></td>
                                    <td style={{ padding: "6px" }}>{p.observacao}</td>
                                    <td style={{ padding: "6px" }}>
                                        <Button
                                            justIcon
                                            round
                                            simple
                                            color="success"
                                            className="edit"
                                            onClick={() => abrirEdicaoStatus(p)}
                                        >
                                            <Tooltip title="Editar Status" id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }}>
                                                <Edit />
                                            </Tooltip>
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                    <hr/>
                    <h5>Logs de Auditoria</h5>
                    {logs.length === 0 &&
                        <p>Nenhum log encontrado.</p>
                    }
                    {logs.length > 0 &&
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr style={{ textAlign: "left", borderBottom: "1px solid #ddd" }}>
                                    <th style={{ padding: "6px" }}>Data/Hora</th>
                                    <th style={{ padding: "6px" }}>Usuário</th>
                                    <th style={{ padding: "6px" }}>Ação</th>
                                    <th style={{ padding: "6px" }}>Observação</th>
                                </tr>
                            </thead>
                            <tbody>
                                {logs.map((l) => (
                                    <tr key={l.royaltieLogId} style={{ borderBottom: "1px solid #eee" }}>
                                        <td style={{ padding: "6px" }}>{formateDateandTime(l.dataHora)}</td>
                                        <td style={{ padding: "6px" }}>{l.nomeUsuario}</td>
                                        <td style={{ padding: "6px" }}>{formatarTextoEnum(l.acaoRealizada)}</td>
                                        <td style={{ padding: "6px" }}>{l.observacao}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    }
                </GridItem>
            </GridContainer>

            <Dialog
                open={modalParcela !== null}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setModalParcela(null)}
                fullWidth
            >
                <DialogTitle>
                    Editar Status da Parcela
                    <Close
                        style={{ float: "right", cursor: "pointer" }}
                        onClick={() => setModalParcela(null)}
                    />
                </DialogTitle>
                <DialogContent>
                    <FormControl fullWidth style={{ marginBottom: "16px" }}>
                        <label className="select__label">Status *</label>
                        <Select
                            classNamePrefix="select"
                            styles={ValidSelect(false)}
                            options={opcoesStatusParcela}
                            value={opcoesStatusParcela.find((o) => o.value === modalStatus)}
                            onChange={(value) => setModalStatus(value ? value.value : "NaoPago")}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <TextField
                            error={modalError !== "" && (!modalObservacao || modalObservacao.trim() === "")}
                            variant="outlined"
                            label="Observação *"
                            multiline
                            rows={3}
                            value={modalObservacao}
                            onChange={(e) => setModalObservacao(e.target.value)}
                        />
                    </FormControl>
                    {modalError !== "" &&
                        <FormHelperText>
                            <span className="obg">{modalError}</span>
                        </FormHelperText>
                    }
                </DialogContent>
                <DialogActions>
                    <Button color="transparent" onClick={() => setModalParcela(null)}>
                        Cancelar
                    </Button>
                    <Button color="primary" onClick={salvarStatus} disabled={salvandoStatus}>
                        Salvar {salvandoStatus && <span> ...</span>}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default function ParcelamentoRoyalties() {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();

    const { register, errors, setValue, clearError, getValues, setError } = useForm({ mode: "onChange" });

    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [estabelecimento, setestabelecimento] = React.useState(0);
    const [list, setlist] = React.useState([]);
    const [loading, setloading] = React.useState(false);
    const [loadingSalvar, setloadingSalvar] = React.useState(false);
    const [loadingXlsx, setloadingXlsx] = React.useState(false);

    const [showFormView, setshowFormView] = React.useState(false);
    const [estabelecimentoNovo, setestabelecimentoNovo] = React.useState("");
    const [editingId, setEditingId] = React.useState(null);
    const [editItem, setEditItem] = React.useState(null);
    const [novoDataInicioCobranca, setnovoDataInicioCobranca] = React.useState("");

    const [dtini, setdtini] = React.useState("");
    const [dtfim, setdtfim] = React.useState("");

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });

    const irParaTopo = () => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    };

    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification(prev => ({ ...prev, show: false }));
        }, 6000);
    };

    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/" + session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                setisLoadingEstabelecimento(false);
                return false;
            }

            let lista = [];
            lista = [{ estabelecimentoId: 0, descricao: "Selecione..." }, ...result.data];

            setisLoadingEstabelecimento(false);
            setestabelecimentos(lista);
            return true;
        });
    };

    useEffect(() => {
        LoadEstabelecimentos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleEstabelecimentoChange = event => {
        let value = event;
        setestabelecimento(value);
        setValue("estabelecimento", value);
        if (value !== "")
            clearError("estabelecimento");
    };

    const handleEstabelecimentoNovoChange = event => {
        let value = event;
        setestabelecimentoNovo(value);
        setValue("novo_estabelecimento", value);
        if (value !== "")
            clearError("novo_estabelecimento");
    };

    const validarPeriodo = () => {
        if (!dtini && !dtfim) return true;

        if (!dtini || !validateDate(dtini)) {
            showNotification("Informe uma Data Inicial válida.", "warning");
            return false;
        }
        if (!dtfim || !validateDate(dtfim)) {
            showNotification("Informe uma Data Final válida.", "warning");
            return false;
        }
        if (convertDate(dtini) > convertDate(dtfim)) {
            showNotification("Data Inicial deve ser anterior ou igual à Data Final.", "warning");
            return false;
        }
        return true;
    };

    const validarFiltrosBusca = (estId) => {
        if (!estId || estId === 0) {
            showNotification("Selecione o Estabelecimento.", "warning");
            return false;
        }
        if (!dtini || !validateDate(dtini)) {
            showNotification("Informe a Data Inicial.", "warning");
            return false;
        }
        if (!dtfim || !validateDate(dtfim)) {
            showNotification("Informe a Data Final.", "warning");
            return false;
        }
        if (convertDate(dtini) > convertDate(dtfim)) {
            showNotification("Data Inicial deve ser anterior ou igual à Data Final.", "warning");
            return false;
        }
        return true;
    };

    const handleClickPesquisa = (estId) => {
        let estabId = estId !== undefined ? (estId || 0) : (estabelecimento || 0);
        if (!validarFiltrosBusca(estabId)) return;

        setloading(true);
        const dataIni = convertDate(dtini);
        const dataFim = convertDate(dtfim);

        ParcelamentoRoyaltiesService.getByEstabelecimento(estabId, dataIni, dataFim).then(result => {
            setloading(false);
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                return false;
            }
            if (result.data.length === 0) {
                showNotification(t('information_message.no_records_found') || 'Nenhum registro encontrado', 'warning');
            }
            setlist(result.data);
        });
    };

    const handleNovo = () => {
        let estId = estabelecimento > 0 ? estabelecimento : "";
        setEditingId(null);
        setValue("novo_estabelecimento", estId);
        setestabelecimentoNovo(estId);
        setValue("novo_mesAno", "");
        setValue("novo_valor", "");
        setValue("novo_parcelas", "");
        setValue("novo_observacao", "");
        setnovoDataInicioCobranca("");
        clearError("novo_estabelecimento");
        clearError("novo_mesAno");
        clearError("novo_valor");
        clearError("novo_parcelas");
        clearError("novo_observacao");

        setshowFormView(true);
        irParaTopo();
    };

    const handleEditar = (item) => {
        setEditingId(item.parcelamentoRoyaltieId);
        setestabelecimentoNovo(item.estabelecimentoId);
        setnovoDataInicioCobranca(item.dataInicioCobranca ? moment(item.dataInicioCobranca).format("DD/MM/YYYY") : "");
        setEditItem(item);

        setshowFormView(true);
        irParaTopo();
    };

    useEffect(() => {
        if (!showFormView || !editItem) return;

        setValue("novo_estabelecimento", editItem.estabelecimentoId);
        setValue("novo_mesAno", editItem.mesAnoReferencia);
        setValue("novo_valor", transformValueFloattoFormated(editItem.valor));
        setValue("novo_parcelas", editItem.parcelas);
        setValue("novo_observacao", editItem.observacao || "");
        clearError("novo_observacao");

        setEditItem(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showFormView, editItem]);

    const handleSalvarNovo = () => {
        let formValues = getValues();
        let obs = formValues.novo_observacao;

        let hasError = false;
        if (!obs || obs.trim() === "") { setError("novo_observacao", "required", t('label.required')); hasError = true; }

        const dataInicioCobranca = novoDataInicioCobranca && validateDate(novoDataInicioCobranca)
            ? convertDate(novoDataInicioCobranca)
            : null;

        if (editingId) {
            if (hasError) return;

            let dto = {
                usuarioId: session.id,
                observacao: obs,
                dataInicioCobranca: dataInicioCobranca,
            };

            setloadingSalvar(true);
            ParcelamentoRoyaltiesService.editar(editingId, dto).then(result => {
                setloadingSalvar(false);
                if (!result || (result.status !== 200 && result.status !== 201)) {
                    showNotification(extrairMensagemErro(result), 'danger');
                    return false;
                }
                showNotification(t('information_message.registered_successfully') || "Atualizado com sucesso!", "success");
                setshowFormView(false);
                setEditingId(null);
                irParaTopo();

                setloading(true);
                ParcelamentoRoyaltiesService.getByEstabelecimento(estabelecimento).then(res => {
                    setloading(false);
                    if (res.status === 200) {
                        setlist(res.data);
                    }
                });
            });
            return;
        }

        let est = estabelecimentoNovo;
        let m = formValues.novo_mesAno;
        let v = formValues.novo_valor;
        let p = formValues.novo_parcelas;

        if (!est || est === 0) { setError("novo_estabelecimento", "required", t('label.required')); hasError = true; }
        if (!m || m.length < 7) { setError("novo_mesAno", "required", t('label.required')); hasError = true; }
        if (!v) { setError("novo_valor", "required", t('label.required')); hasError = true; }
        if (!p) { setError("novo_parcelas", "required", t('label.required')); hasError = true; }

        if (hasError) return;

        let dto = {
            FranquiaId: session.franquiaId,
            EstabelecimentoId: est,
            UsuarioId: session.id,
            MesAnoReferencia: m,
            Valor: typeof v === 'string' ? transformValueFormatedtoFloat(v) : parseFloat(v),
            Parcelas: parseInt(p),
            Observacao: obs,
            DataInicioCobranca: dataInicioCobranca,
        };

        setloadingSalvar(true);

        ParcelamentoRoyaltiesService.criar(dto).then(result => {
            setloadingSalvar(false);
            if (result.status !== 200 && result.status !== 201) {
                showNotification(extrairMensagemErro(result), 'danger');
                return false;
            }
            showNotification(t('information_message.registered_successfully') || "Cadastrado com sucesso!", "success");
            setestabelecimento(est);
            setshowFormView(false);
            setEditingId(null);
            irParaTopo();

            setloading(true);
            ParcelamentoRoyaltiesService.getByEstabelecimento(est).then(res => {
                setloading(false);
                if (res.status === 200) {
                    setlist(res.data);
                }
            });
        });
    };

    const handleExportarXlsx = () => {
        if (!validarPeriodo()) return;

        setloadingXlsx(true);
        const filtro = {
            franquiaId: session.franquiaId,
            estabelecimentos: estabelecimento > 0 ? [estabelecimento] : [],
            dataIni: dtini && validateDate(dtini) ? convertDate(dtini) : null,
            dataFim: dtfim && validateDate(dtfim) ? convertDate(dtfim) : null,
        };

        ParcelamentoRoyaltiesService.exportarXlsx(filtro).then((result) => {
            setloadingXlsx(false);
            if (!result.ok) {
                showNotification(result.message, "danger");
                return;
            }

            const blobUrl = window.URL.createObjectURL(result.blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = `ParcelamentoRoyalties_${moment().format("DDMMYYYYHHmmss")}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(blobUrl);
        });
    };

    let columns = [
        {
            Header: "Mês/Ano",
            accessor: "mesAnoReferencia",
        },
        {
            Header: "Valor",
            accessor: "valor",
            Cell: (props) => {
                if (props.value == null) return "";
                let valor = transformValueFloattoFormated(props.value);
                return valor;
            }
        },
        {
            Header: "Parcelas",
            accessor: "parcelas",
        },
        {
            Header: "Status",
            accessor: "statusParcelamentoRoyaltie",
            Cell: (props) => {
                if (props.value == null) return "";
                if (props.value === 0 || props.value === "0") return "Ativo";
                if (props.value === 1 || props.value === "1") return "Cancelado";
                if (props.value === 2 || props.value === "2") return "Finalizado";
                return props.value;
            }
        },
        {
            Header: "Data Início Cobrança",
            accessor: "dataInicioCobranca",
            Cell: (props) => {
                if (props.value == null) return "";
                return formateDate(props.value);
            }
        },
        {
            Header: "Data Cadastro",
            accessor: "dataCadastro",
            Cell: (props) => {
                if (props.value == null) return "";
                return formateDateandTime(props.value);
            }
        },
        {
            Header: "Usuário",
            accessor: "nomeUsuario",
        },
        {
            Header: "Ações",
            accessor: "parcelamentoRoyaltieId",
            filterable: false,
            sortable: false,
            Cell: (props) => (
                <div className="actions-right">
                    <Button
                        justIcon
                        round
                        simple
                        color="success"
                        className="edit"
                        onClick={(e) => { e.stopPropagation(); handleEditar(props.original); }}
                    >
                        <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }}>
                            <Edit />
                        </Tooltip>
                    </Button>
                </div>
            )
        }
    ];

    return (
        <>
            <div className="maxContent">
                <form className="no-print">

                    {showFormView &&
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <Card>
                                    <CardHeader color="primary" icon>
                                        <CardIcon color="primary">
                                            <Assignment />
                                        </CardIcon>
                                        <h4 className={classes.cardIconTitle}>
                                            {editingId ? "Editar Parcelamento de Royalties" : "Novo Parcelamento de Royalties"}
                                        </h4>
                                    </CardHeader>
                                    <CardBody>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <label className={errors.novo_estabelecimento ? "select__label select__label_error" : "select__label"}>
                                                        {t('label.establishment')} *</label>
                                                    <Select
                                                        classNamePrefix="select"
                                                        styles={ValidSelect(errors.novo_estabelecimento ? true : false)}
                                                        isSearchable={true}
                                                        isDisabled={editingId ? true : false}
                                                        isLoading={isLoadingEstabelecimento}
                                                        name="novo_estabelecimento"
                                                        placeholder={t('label.select') + "..."}
                                                        options={estabelecimentos.filter(e => e.estabelecimentoId !== 0)}
                                                        value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimentoNovo)}
                                                        getOptionLabel={({ descricao }) => descricao}
                                                        getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                                        onChange={(value) => handleEstabelecimentoNovoChange(value ? value.estabelecimentoId : "")}
                                                        ref={() => register({ name: "novo_estabelecimento" })}
                                                    />
                                                    {errors.novo_estabelecimento &&
                                                        <FormHelperText>
                                                            <span className="obg"> {t('label.required')} </span>
                                                        </FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={3} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.novo_mesAno ? true : false}
                                                        variant="outlined"
                                                        disabled={editingId ? true : false}
                                                        inputRef={register({ required: true })}
                                                        label={"Mês/Ano *"}
                                                        name="novo_mesAno"
                                                        InputProps={{ inputComponent: MaskMonthYear }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                    {errors.novo_mesAno && <FormHelperText><span className="obg"> {t('label.required')}</span></FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={3} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.novo_valor ? true : false}
                                                        variant="outlined"
                                                        disabled={editingId ? true : false}
                                                        inputRef={register({ required: true })}
                                                        label={"Valor *"}
                                                        name="novo_valor"
                                                        InputProps={{ inputComponent: MaskDecimal }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                    {errors.novo_valor && <FormHelperText><span className="obg"> {t('label.required')}</span></FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={3} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.novo_parcelas ? true : false}
                                                        variant="outlined"
                                                        disabled={editingId ? true : false}
                                                        inputRef={register({ required: true })}
                                                        label={"Parcelas *"}
                                                        name="novo_parcelas"
                                                        InputProps={{ inputComponent: MaskInt }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                    {errors.novo_parcelas && <FormHelperText><span className="obg"> {t('label.required')}</span></FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={3} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <label className="select__label">Data Início Cobrança</label>
                                                    <Datetime
                                                        locale={getLocale()}
                                                        dateFormat={getStringFormatDate()}
                                                        timeFormat={false}
                                                        value={novoDataInicioCobranca}
                                                        onChange={(date) => {
                                                            const formatted =
                                                                typeof date === "object" && date.format
                                                                    ? date.format("DD/MM/YYYY")
                                                                    : date;
                                                            setnovoDataInicioCobranca(formatted);
                                                        }}
                                                        inputProps={{ readOnly: "readonly" }}
                                                    />
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.novo_observacao ? true : false}
                                                        variant="outlined"
                                                        multiline
                                                        rows={2}
                                                        inputRef={register({ required: true })}
                                                        label={"Observação *"}
                                                        name="novo_observacao"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                    {errors.novo_observacao && <FormHelperText><span className="obg"> {t('label.required')}</span></FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                                                <br />
                                                <div className={classes.textCenter}>
                                                    <Button color="transparent" onClick={() => { setshowFormView(false); setEditingId(null); irParaTopo(); }} >
                                                        {t('label.return')}
                                                    </Button>
                                                    <Button onClick={() => handleSalvarNovo()} color="primary" disabled={loadingSalvar}>
                                                        {t('button.to_save')} {loadingSalvar && <div> ... {t('label.loading')}</div>}
                                                    </Button>
                                                </div>
                                            </GridItem>
                                        </GridContainer>

                                        <GridItem md={12}>
                                            {
                                                notification.show &&
                                                <div>
                                                    <br />
                                                    <SnackbarContent
                                                        message={notification.message}
                                                        color={notification.color}
                                                        closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
                                                        close
                                                    />
                                                </div>
                                            }
                                        </GridItem>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </GridContainer>
                    }

                    {!showFormView &&
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <Card>
                                    <CardHeader color="primary" icon>
                                        <CardIcon color="primary">
                                            <Assignment />
                                        </CardIcon>
                                        <h4 className={classes.cardIconTitle}>
                                            {t('sidebar.royalties_installments')}
                                        </h4>
                                    </CardHeader>
                                    <CardBody>
                                        <Button
                                            color="primary"
                                            className={classes.newButton}
                                            onClick={() => handleNovo(true)}
                                        >
                                            {t('button.new')}
                                        </Button>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>
                                                        {t('label.establishment')}</label>
                                                    <Select
                                                        classNamePrefix="select"
                                                        styles={ValidSelect(errors.estabelecimento ? true : false)}
                                                        isSearchable={true}
                                                        isLoading={isLoadingEstabelecimento}
                                                        name="estabelecimento"
                                                        placeholder={t('label.all') + "..."}
                                                        options={estabelecimentos}
                                                        value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                                        getOptionLabel={({ descricao }) => descricao}
                                                        getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                                        onChange={(value) => handleEstabelecimentoChange(value ? value.estabelecimentoId : "")}
                                                        ref={() => register({ name: "estabelecimento" })}
                                                    />
                                                    {errors.estabelecimento &&
                                                        <FormHelperText>
                                                            <span className="obg"> {t('label.required')} </span>
                                                        </FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <label className="select__label">Data Inicial</label>
                                                    <Datetime
                                                        locale={getLocale()}
                                                        dateFormat={getStringFormatDate()}
                                                        timeFormat={false}
                                                        value={dtini}
                                                        onChange={(date) => {
                                                            const formatted =
                                                                typeof date === "object" && date.format
                                                                    ? date.format("DD/MM/YYYY")
                                                                    : date;
                                                            setdtini(formatted);
                                                        }}
                                                        inputProps={{ readOnly: "readonly" }}
                                                    />
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={3}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <label className="select__label">Data Final</label>
                                                    <Datetime
                                                        locale={getLocale()}
                                                        dateFormat={getStringFormatDate()}
                                                        timeFormat={false}
                                                        value={dtfim}
                                                        onChange={(date) => {
                                                            const formatted =
                                                                typeof date === "object" && date.format
                                                                    ? date.format("DD/MM/YYYY")
                                                                    : date;
                                                            setdtfim(formatted);
                                                        }}
                                                        inputProps={{ readOnly: "readonly" }}
                                                    />
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={6}>
                                                <Button
                                                    round
                                                    color="primary"
                                                    onClick={() => handleClickPesquisa(estabelecimento)}
                                                >
                                                    {t('button.search') || "Pesquisar"}
                                                </Button>
                                                <Button
                                                    round
                                                    color="success"
                                                    onClick={handleExportarXlsx}
                                                    disabled={loadingXlsx}
                                                    style={{ marginLeft: 8 }}
                                                >
                                                    {loadingXlsx ? (
                                                        <CircularProgress size={20} color="inherit" />
                                                    ) : (
                                                        "Exportar XLSX"
                                                    )}
                                                </Button>
                                            </GridItem>

                                            <GridItem md={12}>
                                                {
                                                    notification.show &&
                                                    <div>
                                                        <br />
                                                        <SnackbarContent
                                                            message={notification.message}
                                                            color={notification.color}
                                                            closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
                                                            close
                                                        />
                                                    </div>
                                                }
                                            </GridItem>
                                        </GridContainer>

                                        <GridContainer>
                                            <br />
                                            <GridItem xs={12} sm={12} md={12}>
                                                <ReactTable
                                                    loading={loading}
                                                    data={list}
                                                    columns={columns}
                                                    filterable
                                                    defaultFilterMethod={noCaseSensitive}
                                                    defaultPageSize={10}
                                                    minRows={5}
                                                    showPaginationBottom={true}
                                                    className="-striped -highlight"
                                                    previousText={t('button.previous')}
                                                    nextText={t('button.next')}
                                                    loadingText={t('label.loading') + "..."}
                                                    noDataText={t('information_message.no_records_found') || "Nenhum registro encontrado!"}
                                                    pageText={t('label.page')}
                                                    ofText={t('label.of')}
                                                    rowsText={t('label.rows')}
                                                    SubComponent={row => (
                                                        <ParcelamentoDetalhe parcelamento={row.original} session={session} />
                                                    )}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </GridContainer>
                    }
                </form>
            </div>
        </>
    )
}
